/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { InternalTelemetry } from './internal-telemetry';
const _telemetry = new InternalTelemetry();
export { _telemetry as StaticTelemetry };
